import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import "../styles/Home.css";
import HomeClients from "./HomeClients";
import HomeCertificates from "./HomeCertificates";
import HomeCoreValues from "./HomeCoreValues";
import HomeBranches from "./HomeBranches";
import MapLocation from "./MapLocation";
import NewlyAddedClients from "./NewlyAddedClients";
import CompanyProfile from "./CompanyProfile";

function Home() {
  const images = [
    "/images/Indian-canteen-buffet.png",
    "/images/Home-Page-Banner-2.jpg",
    "/images/Home-Page-Banner-3.jpg",
    "/images/Home-Page-Banner-4.png",
  ];

  const greetings = ["Hello", "Namaste", "Pranam", "Vanakkam", "Namaskaram"];
  const [currentGreetingIndex, setCurrentGreetingIndex] = useState(0);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const navigate = useNavigate();

  const profilePdfUrl = "https://laxmihospitalityservices.in/Laxmi_Hospitality_Services_Profile.pdf";

  useEffect(() => {
    const greetingInterval = setInterval(() => {
      setCurrentGreetingIndex((prev) => (prev + 1) % greetings.length);
    }, 2500);
    return () => clearInterval(greetingInterval);
  }, [greetings.length]);

  useEffect(() => {
    const imageInterval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(imageInterval);
  }, [images.length]);

  const handleContactClick = () => {
    navigate("/contactus");
  };

  return (
    <>
  <Helmet>
  <title>Laxmi Hospitality Services | Industrial Catering Since 2009</title>
  <meta
    name="description"
    content="Founded in 2009, Laxmi Hospitality Services specializes in industrial catering, serving 14,550+ meals daily to India's leading Industries."
  />
  <meta name="robots" content="index, follow" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  

  {/* Canonical URL */}
  <link
    rel="canonical"
    href="https://laxmihospitalityservices.in/"
  />

  {/* Open Graph Meta Tags for Social Media Sharing */}
  <meta property="og:type" content="website" />
  <meta
    property="og:url"
    content="https://laxmihospitalityservices.in/"
  />
  <meta
    property="og:title"
    content="Laxmi Hospitality Services | Industrial Catering Since 2009"
  />
  <meta
    property="og:description"
    content="Founded in 2009, Laxmi Hospitality Services specializes in industrial catering, serving 14,550+ meals daily to India's leading Industries."
  />
  <meta property="og:site_name" content="Laxmi Hospitality Services" />
  <meta property="og:locale" content="en_IN" />

  {/* Complete Organization JSON-LD Schema - HOMEPAGE ONLY */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "@id": "https://laxmihospitalityservices.in/#organization",
        "name": "Laxmi Hospitality Services",
        "url": "https://laxmihospitalityservices.in",
        "logo": {
          "@type": "ImageObject",
          "url": "https://laxmihospitalityservices.in/logo.png"
        },
        "description": "Expert industrial catering services provider since 2009, delivering custom canteen solutions for India's top manufacturing facilities and industrial plants. Serving 14,550+ meals daily across 5 states.",
        "foundingDate": "2009",
        "slogan": "Catering with Passion & Serving with Heart",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Evershine Sapphire, Above SBI Bank, DP Road 9, Chandivali, Powai",
          "addressLocality": "Mumbai",
          "postalCode": "400072",
          "addressRegion": "Maharashtra",
          "addressCountry": "IN"
        },
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "telephone": "+91-9724982104",
            "contactType": "customer service",
            "areaServed": "IN",
            "availableLanguage": ["English", "Hindi", "Marathi"]
          },
          {
            "@type": "ContactPoint",
            "telephone": "+91-9987558691",
            "contactType": "administrator",
            "areaServed": "IN",
            "availableLanguage": ["English", "Hindi"]
          }
        ],
        "email": [
          "sadanandgshetty185@gmail.com",
          "laxmihospitalityservicesind@gmail.com"
        ],
        "areaServed": [
          {
            "@type": "State",
            "name": "Maharashtra"
          },
          {
            "@type": "State", 
            "name": "Gujarat"
          },
          {
            "@type": "State",
            "name": "Daman"
          },
          {
            "@type": "State",
            "name": "Andhra Pradesh"
          },
          {
            "@type": "State",
            "name": "Telangana"
          }
        ],
        "serviceArea": {
          "@type": "Country",
          "name": "India"
        },
        "knowsAbout": [
          "Industrial Catering",
          "Client based Catering",
          "Factory Canteen Management",
          "Manufacturing Facility Food Services",
          "Industrial Food Service Management",
          "Employee Meal Programs",
          "Large Scale Catering",
          "Shift-based Catering Solutions"
        ],
        "hasCredential": {
          "@type": "EducationalOccupationalCredential",
          "credentialCategory": "GST Registration",
          "recognizedBy": {
            "@type": "Organization",
            "name": "Government of India"
          }
        },
        "founder": {
          "@type": "Person",
          "name": "Mamata Sadanand Shetty"
        },
        "numberOfEmployees": {
          "@type": "QuantitativeValue",
          "value": "500"
        },
        "sameAs": [
          "https://www.linkedin.com/company/laxmi-hospitality-services/",
          "https://www.instagram.com/laxmi_hospitality_services/"
        ]
      }
    `}
  </script>

  {/* Website JSON-LD Schema */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "@id": "https://laxmihospitalityservices.in/#website",
        "url": "https://laxmihospitalityservices.in",
        "name": "Laxmi Hospitality Services",
        "description": "Expert industrial catering across 5 states, serving 14,550+ meals daily to India's leading Industries.",
        "publisher": {
          "@type": "Organization",
          "@id": "https://laxmihospitalityservices.in/#organization"
        },
        "inLanguage": "en-IN"
      }
    `}
  </script>

  {/* Local Business JSON-LD Schema */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "@id": "https://laxmihospitalityservices.in/#localbusiness",
        "name": "Laxmi Hospitality Services",
        "image": "https://laxmihospitalityservices.in/logo.png",
        "description": "Leading industrial catering service provider in Mumbai, specializing in factory canteen management and employee meal programs since 2009.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Evershine Sapphire, Above SBI Bank, DP Road 9, Chandivali, Powai",
          "addressLocality": "Mumbai",
          "addressRegion": "Maharashtra",
          "postalCode": "400072",
          "addressCountry": "IN"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "19.1176",
          "longitude": "72.9060"
        },
        "telephone": "+91-9724982104",
        "email": "laxmihospitalityservicesind@gmail.com",
        "url": "https://laxmihospitalityservices.in",
        "openingHours": "Mo-Sa 06:00-22:00",
        "priceRange": "₹₹",
        "paymentAccepted": ["Cash", "Credit Card", "Bank Transfer", "UPI"],
        "currenciesAccepted": "INR",
        "sameAs": [
          "https://www.linkedin.com/company/laxmi-hospitality-services/",
          "https://www.instagram.com/laxmi_hospitality_services/"
        ]
      }
    `}
  </script>

 

  {/* BreadcrumbList JSON-LD Schema */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "@id": "https://laxmihospitalityservices.in/#breadcrumb",
        "name": "Website Breadcrumb",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://laxmihospitalityservices.in/"
          },
           {
            "@type": "ListItem",
            "position": 2,
            "name": "About Us",
            "item": "https://laxmihospitalityservices.in/aboutus"
          },

          {
            "@type": "ListItem",
            "position": 3,
            "name": "Our Services",
            "item": "https://laxmihospitalityservices.in/services"
          },

          {
            "@type": "ListItem",
            "position": 4,
            "name": "Clients",
            "item": "https://laxmihospitalityservices.in/clients"
          },
           {
            "@type": "ListItem",
            "position": 5,
            "name": "Our Team",
            "item": "https://laxmihospitalityservices.in/ourteam"
          },
          {
            "@type": "ListItem",
            "position": 6,
            "name": "Contact Us",
            "item": "https://laxmihospitalityservices.in/contactus"
          }
        ]
      }
    `}
  </script>
</Helmet>

    <div className="home-page-container">
      <div className="home-image-carousel">
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Hero Banner Laxmi hospitality services image-${index}`}
            title={`Hero Banner Laxmi hospitality services image-${index}`}
            className={`carousel-image ${
              index === currentImageIndex ? "active" : ""
            }`}
          />
        ))}

        <div className="home-welcome-overlay">
          <h1 className="home-welcome-title">
            Welcome to Laxmi Hospitality Services
          </h1>
          <h2 className="home-greeting-text">
            {greetings[currentGreetingIndex]}
          </h2>
          <h3 className="home-caption-text">
            Catering with Passion & Serving with Heart
          </h3>
          <a
            href={profilePdfUrl}
            download="Laxmi_Hospitality_Services_Profile.pdf"
            className="home-hero-cta"
            title="Download Our Company Profile"
            aria-label="Download the Laxmi Hospitality Services company profile"
          >
            Explore Our Profile
          </a>
        </div>

        <div className="carousel-dots">
          {images.map((_, index) => (
            <span
              key={index}
              className={`dot ${
                index === currentImageIndex ? "active-dot" : ""
              }`}
              onClick={() => setCurrentImageIndex(index)}
            ></span>
          ))}
        </div>
      </div>

      <section className="home-section">
        <div className="home-content-wrapper">
          <div className="home-images-container">
            <div className="image-wrapper">
              <img
                src="/images/Home-About-us-image2.jpg"
                alt="North Indian Dish 1"
                className="catering-image"
              />
            </div>
            <div className="image-wrapper second-image">
              <img
                src="/images/Home-About-us-image.jpg"
                alt="North Indian Dish 2"
                className="catering-image"
              />
            </div>
            <div className="since-badge">
              <span className="since-text">Since</span>
              <span className="year-text">2009</span>
            </div>
          </div>

          <div className="home-text-content">
            <p className="about-us-label">ABOUT US</p>
            <h2 className="main-headline">
              Indulge in a celebration with great food!
            </h2>
              <p className="body-paragraph">
                Since 2009, Laxmi Hospitality Service has reimagined workplace
                dining, turning canteens into community spaces where quality
                meets care. We serve more than meals: we serve trust. With
                precision catering, unwavering hygiene, and a people first
                approach, we craft daily food experiences that fuel productivity
                and celebrate partnership. When India’s leading industries rely
                on us, it’s because we deliver more than nourishment; we deliver
                peace of mind.
              </p>
            <button className="book-now-button" onClick={handleContactClick}>
              Contact Now <span className="arrow-icon">&#8594;</span>
            </button>
          </div>
        </div>
      </section>

      <NewlyAddedClients/>
      <HomeClients />
      <HomeCertificates />
      <HomeCoreValues />
      <MapLocation />
      <HomeBranches />
      <CompanyProfile />
    </div>
    </>
  );
}

export default Home;
